// =====================================================
// 📁 POSCategoryScrollButton.tsx
// =====================================================

import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Props {
  direction: 'left' | 'right';

  onClick: () => void;

  disabled?: boolean;
}

const POSCategoryScrollButton = ({
  direction,
  onClick,
  disabled = false,
}: Props) => {
  const Icon = direction === 'left' ? ChevronLeft : ChevronRight;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="
      hidden

      h-[42px]
      w-[42px]

      shrink-0
      items-center
      justify-center

      rounded-xl

      border

      border-slate-300
      bg-white

      text-slate-500

      shadow-1

      transition-all
      duration-200

      hover:border-primary/50
      hover:bg-primary/10
      hover:text-primary
      hover:shadow-2

      disabled:cursor-not-allowed
      disabled:opacity-50

      dark:border-form-strokedark
      dark:bg-boxdark-2
      dark:text-bodydark2

      dark:hover:border-primary/50
      dark:hover:bg-primary/15
      dark:hover:text-primary

      lg:flex
    "
    >
      <Icon className="h-4 w-4" />
    </button>
  );
};

export default POSCategoryScrollButton;
